import {ChangeDetectorRef, Component, Inject, OnDestroy} from '@angular/core';
import {Subject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConfirmationActionTypes} from "./confirmation-action.types";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {NgClass, NgIf} from "@angular/common";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {finalize} from "rxjs/operators";

@Component({
    selector: 'app-confirmation-action',
    templateUrl: './confirmation-action.component.html',
    styleUrls: ['./confirmation-action.component.scss'],
    standalone: true,
    imports: [MatButtonModule, MatIconModule, NgIf, NgClass, MatProgressSpinnerModule],
})
export class ConfirmationActionComponent implements OnDestroy
{
    data: ConfirmationActionTypes;
    loading: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) confirmationData: any,
        private _matDialogRef: MatDialogRef<ConfirmationActionComponent>,
    )
    {
        this.data = confirmationData?.data || confirmationData;
    }

    ngOnDestroy(): void
    {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    getIconConfig(): { icon: string; color: string; bg: string }
    {
        switch (this.data.type)
        {
            case 'warning':
                return { icon: 'mat_solid:warning', color: 'text-orange-500', bg: 'bg-orange-50' };
            case 'error':
                return { icon: 'mat_solid:error', color: 'text-red-500', bg: 'bg-red-50' };
            case 'success':
                return { icon: 'mat_solid:check_circle', color: 'text-green-500', bg: 'bg-green-50' };
            case 'info':
                return { icon: 'mat_solid:info', color: 'text-blue-500', bg: 'bg-blue-50' };
            default:
                return { icon: 'heroicons_outline:exclamation-circle', color: 'text-blue-600', bg: 'bg-blue-50' };
        }
    }

    close(): void
    {
        this._matDialogRef.close({ action: 'close' });
    }

    yesAction(): void
    {
        if (this.data.yesButton.action)
        {
            this.loading = true;
            this._changeDetectorRef.markForCheck();

            this.data.yesButton.action().pipe(
                finalize(() =>
                {
                    this.loading = false;
                    this._changeDetectorRef.markForCheck();
                })
            ).subscribe({
                next: () =>
                {
                    this._matDialogRef.close({ action: 'yes' });
                },
                error: () =>
                {
                    this._matDialogRef.close({ action: 'error' });
                }
            });
        }
        else
        {
            this._matDialogRef.close({ action: 'yes' });
        }
    }

    noAction(): void
    {
        this._matDialogRef.close({ action: 'no' });
    }

    cancelAction(): void
    {
        this._matDialogRef.close({ action: 'cancel' });
    }
}
